import * as React from "react";
import type { UsersCampaignLabelType } from "@graphql/__generated__/types";
import styles from "./index.module.css";

type Props = {
  campaignLabels: Array<
    Pick<UsersCampaignLabelType, "iconPath" | "displayText">
  >;
};

const ShopCampaignLabel: React.FC<Props> = ({ campaignLabels }) => {
  return (
    <ul className={styles.shopCampaignLabelList}>
      {campaignLabels.map((label, index) => {
        return (
          <li className={styles.shopCampaignLabelItem} key={index}>
            {label.displayText}
          </li>
        );
      })}
    </ul>
  );
};

export default ShopCampaignLabel;
